
import { MockScenario, ScenarioPreset } from './mock.types';

export const scenarioPresets: Record<MockScenario, ScenarioPreset> = {
  'dv1-standard': {
    RopcAuth: 'success',
    MlaAuthToken: 'multiple-borrowers',
    MlaSsoToken: 'success',
    CpSsoLogin: 'success',
    CpUlaToken: 'success',

    ProcessLoginMFA: 'mfa-required',
    SendLoginMFACode: 'success',
    VerifyLoginMFACode: 'success',

    GetUserProfile: 'multiple-loans',
    ValidateLoan: 'success',
    RegisterLoan: 'success',
    CheckRegistration: 'success',

    GetLoans: 'multiple-loans',
    GetLoan: 'default',
    GetLoanMessages: 'with-messages',
    GetLoanFlags: 'all-features',
    GetLoanSummary: 'default',
    GetOtherLoans: 'default',
    GetQrpcTemplate: 'default',
    GetLossMitigationData: 'default',

    GetPaymentPageData: 'with-fees',
    GetBankAccounts: 'multiple-accounts',
    SubmitPayment: 'success',
    GetPaymentHistory: 'with-history',
    ValidateRoutingNumber: 'valid',
    UpdatePayment: 'success',
    GetPendingPaymentById: 'default',
    DeletePaymentProfile: 'success',
    SetDefaultPaymentProfile: 'success',

    GetAutopayPayments: 'active-monthly',
    GetDeletedPayments: 'no-deleted',
    SetupAutopay: 'success',
    UpdateAutopay: 'success',
    CancelAutopay: 'success',

    GetHelocLoanInfo: 'draw-eligible',
    GetHelocDrawRecords: 'no-pending',
    GetDrawEligibility: 'eligible',
    DrawFunds: 'success',
    GetHelocAutopayStatus: 'disabled',
    LoanLookup: 'found',

    GetDocuments: 'with-documents',
    DownloadDocument: 'success',

    GetSecureMessages: 'with-messages',
    GetUnreadCount: 'default',
    SendMessage: 'success',
    MarkMessageRead: 'success',
    DeleteMessage: 'success',

    GetContactInfo: 'complete-info',
    UpdateContactInfo: 'success',

    GetTcpaDetails: 'already-consented',
    UpdateTcpaConsent: 'success',

    UpdateLoanPaperlessSettings: 'success',

    RequestPayoffQuote: 'success',

    GetCreditWidgetUrl: 'default',

    GetOriginationLoanDetails: 'with-coborrower',
    GetPaymentLockStatus: 'default',
    GetURLAs: 'default',
    GetCreditCardConfig: 'default',
    ZipCodeLookup: 'default',
    GetLoanProgress: 'documents-pending',
    GetLoanTeam: 'with-chat',
    GetOriginationTodos: 'some-completed',

    LoadDocumentHistory: 'default',
    LoadDocumentRequests: 'some-completed',
    UploadDocument: 'success',
    GetDocumentEmbed: 'default',
    ConfirmDocument: 'success',
    GetDocumentMetadata: 'default',

    CreateDataFirstSession: 'default',
    CompleteAssetVerification: 'success',
    CreateIncomeEmploymentSession: 'default',
    CompleteIncomeVerification: 'success',
    CompleteEmploymentVerification: 'success',
    CompleteSecondaryIncomeVerification: 'success',

    LoadBorrowerActions: 'some-completed',
    GetBorrowerAction: 'default',
    CompleteAction: 'success',
    SubmitOriginationPayment: 'success',

    GetInsuranceEligibility: 'default',
    LoadInsurance: 'with-insurance',
    SubmitInsurance: 'success',
    UpdateInsurance: 'success',

    LoadGiftLetters: 'default',
    SubmitGiftLetter: 'success',

    LoadAppraisal: 'scheduled',

    GetEConsent: 'consented',
    UpdateEConsent: 'success',
    GetOriginationTcpaConsent: 'consented',
    UpdateOriginationTcpaConsent: 'success',
    UpdateInstantVerificationConsent: 'success',

    LoadOriginationContacts: 'default',

    LoadOriginationMessages: 'with-conversation',
    SendOriginationMessage: 'success',
    MarkOriginationMessagesRead: 'success',
    RequestCallback: 'success',

    CheckRegistrationToken: 'default',
    ConfirmRegistration: 'success',
    GetB2CFeatureFlag: 'default',
    LoadOriginationUserProfile: 'default',
    UpdateOriginationProfile: 'success',
    GetUserLoans: 'default',

    GetOriginationApplications: 'active-and-funded',

    GetMlaBorrowerInfo: 'with-coborrower',
    GetMlaDashboard: 'active-and-funded',

    SearchFinancialInstitutions: 'default',
    GetFinancialInstitution: 'default',
    GetFeaturedInstitutions: 'default',

    CreateLoan: 'default',
    UpdateLoan: 'default',
    CreateBorrower: 'default',
    UpdateBorrower: 'default',
    CreateIncome: 'default',
    UpdateIncome: 'default',
    DeleteIncome: 'default',
    CreateAsset: 'default',
    UpdateAsset: 'default',
    DeleteAsset: 'default',
    SubmitApplication: 'success',
  },
};

export function getScenarioForEndpoint(
  endpointName: string,
  activeScenario?: string,
  endpointOverride?: string
): string {
  if (endpointOverride) {
    return endpointOverride;
  }

  if (activeScenario && activeScenario in scenarioPresets) {
    const preset = scenarioPresets[activeScenario as MockScenario];
    const scenarioValue = preset[endpointName as keyof ScenarioPreset];
    if (scenarioValue) {
      return scenarioValue;
    }
  }

  return 'default';
}
